export default class AdvertisingBannerService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('advertisingBannerRecipients', params)
	}

	getRecipientDeviceList(params){
		return this.apiService.callGet('advertisingBannerRecipients/devicesList', params)
	}

	deleteRecipient(params){
		return this.apiService.callDelete('advertisingBannerRecipients/deleteRecipient/', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/AdvertisingBannerRecipientService.js